import {IController} from "angular";
import {User, UserDto} from "../../../users/model/User";
import {ToastNotificationServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import './borrower-loan-info.scss';
import {UserGranredAuthorityName} from "../../../router/const/AllPermitions";
import {UserService} from "../../../users_service/service/user.service";
import {UserView} from "../../../users/model/UserFilter";
import {Borrower} from "../../../customers/model/Borrower";
import {PrincipalUtil} from "../../../utils/PrincipalUtil";
import {CustomerInfoOptions} from "../../model/CustomerInfoOptions";

export class CustomerProfileLoanInfoController implements IController {

    static instance = {
        controller: ['$mdDialog', UserServiceName, ToastNotificationServiceName, CustomerProfileLoanInfoController],
        template: require('./borrower-loan-info.html'),
        bindings: {
            'customer': '<',
            'options' : '<'
        }
    };

    private customer: Borrower;
    private originalLoInputDisabled: boolean;
    private allowTransferLoanOfficer: boolean = false;
    private originalCustomerOriginalLO: User;
    private options: CustomerInfoOptions;

    constructor(private $mdDialog: angular.material.IDialogService,
                private employeeService: UserService,
                private notificationService: ToastNotificationService) {

    }

    $onInit(): void {
        this.originalCustomerOriginalLO = this.customer.originalLoanOfficer;
        this.initTransferLoanOfficerAllowed();
        this.initCustomerInfoOptions();
        this.initOriginalLoInputDisabled();
    }

    private initTransferLoanOfficerAllowed() {
        //if component is readonly, the `allowTransferLoanOfficer` should be false anyway
        if (!this.options.readonly) {
            PrincipalUtil.hasAuthorityPromise(UserGranredAuthorityName.TRANSFER_LO)
                .then(status => this.allowTransferLoanOfficer = status);
        }
    }

    private initCustomerInfoOptions() {
        this.options = this.options || {
            readonly: false
        }
    }


    private initOriginalLoInputDisabled() {
        //if component is readonly, the LO input should be disabled
        this.originalLoInputDisabled = this.options.readonly;
    }

    getDownPayment() {
        let selectedContact = this.customer;
        if (selectedContact.loanInfo.downPayment) {
            return selectedContact.loanInfo.downPayment;
        } else {
            if (selectedContact.loanInfo.propertyPrice && selectedContact.loanInfo.loanAmount) {
                return selectedContact.loanInfo.propertyPrice - selectedContact.loanInfo.loanAmount;
            }
        }
    }

    changeOriginalLO = () => {
        this.originalLoInputDisabled = false;
    };


    showConfirmChangeOriginalLoDialog = (selectedLO: User) => {
        if (selectedLO && selectedLO.id != this.originalCustomerOriginalLO.id) {
            this.originalLoInputDisabled = true;
            let confirm = this.getConfirmChangesCustomersOriginalLO(selectedLO);
            this.$mdDialog.show(confirm).then(
                resp => {
                    this.employeeService.changeCustomerOriginalLoanOfficer(selectedLO, this.customer)
                        .then(
                            resp => this.originalCustomerOriginalLO = selectedLO,
                            () => this.notificationService.generateErrorMessage("Failed to change customer original LO")
                        )
                },
                () => {
                    this.customer.originalLoanOfficer = this.originalCustomerOriginalLO;
                });
        }
    };

    queryEmployee = (query: string): angular.IPromise<UserDto[]> => this.employeeService
        .queryEmployee({
            query: query,
            showDisabled: true,
            showDeleted: false,
            branchesIds: [],
            userIds: [],
            view: UserView.AUTOCOMPLETE
        }).then(resp => {
            if (resp.status == 200) {
                return resp.data;
            } else {
                this.notificationService.generateErrorMessage('Failed to fetch users');
            }
        });

    private getConfirmChangesCustomersOriginalLO(selectedLO: User) {
        return this.$mdDialog.confirm()
            .title(`Are you sure you want to change the customers original Loan Officer?`)
            .textContent(`Customer is going to be reassigned to ${selectedLO.name}.`)
            .ok('Yes')
            .cancel('No Cancel');
    }

}
